import { createContext, useContext, useState, useCallback } from 'react';

export const LANGUAGES = {
    en: { name: 'English', flag: '🇬🇧', nativeName: 'English' },
    fr: { name: 'French', flag: '🇫🇷', nativeName: 'Français' },
    it: { name: 'Italian', flag: '🇮🇹', nativeName: 'Italiano' },
    es: { name: 'Spanish', flag: '🇪🇸', nativeName: 'Español' },
    de: { name: 'German', flag: '🇩🇪', nativeName: 'Deutsch' },
    pt: { name: 'Portuguese', flag: '🇵🇹', nativeName: 'Português' },
    zh: { name: 'Chinese', flag: '🇨🇳', nativeName: '中文' },
    ja: { name: 'Japanese', flag: '🇯🇵', nativeName: '日本語' },
    ko: { name: 'Korean', flag: '🇰🇷', nativeName: '한국어' },
    ar: { name: 'Arabic', flag: '🇸🇦', nativeName: 'العربية' },
    ru: { name: 'Russian', flag: '🇷🇺', nativeName: 'Русский' },
    nl: { name: 'Dutch', flag: '🇳🇱', nativeName: 'Nederlands' },
    tr: { name: 'Turkish', flag: '🇹🇷', nativeName: 'Türkçe' },
    hi: { name: 'Hindi', flag: '🇮🇳', nativeName: 'हिन्दी' },
};

const LanguageContext = createContext(null);

function getStoredLanguage() {
    try {
        return localStorage.getItem('voxoora_language') || 'en';
    } catch {
        return 'en';
    }
}

export function LanguageProvider({ children }) {
    const [language, setLanguageState] = useState(getStoredLanguage);

    const setLanguage = useCallback((lang) => {
        setLanguageState(lang);
        try { localStorage.setItem('voxoora_language', lang); } catch {}
    }, []);

    return (
        <LanguageContext.Provider value={{ language, setLanguage, LANGUAGES }}>
            {children}
        </LanguageContext.Provider>
    );
}

export const useLanguage = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
    return ctx;
};
